module.exports = __webpack_public_path__ + "static/media/18.a4747347.jpg";